import React from "react";
import { useTranslation } from "react-i18next";
const AllWidgets = ({ widget, num, toggleDeviceDetails }) => {
  const { t } = useTranslation();
  return (
    <div
      className="mb-3 bg-white allWidgets d-flex align-items-center px-2 py-2 position-relative cursor"
      onClick={toggleDeviceDetails}
    >
      <span className="widgetIcon rounded-circle ml-2"></span>
      <div className="text-right">
        <p className="m-0 fn12">{widget.caption.replace(t("ویجت"), "")}</p>
        <p className="m-0 fn10">{widget.owner ? t("روشن") : t("خاموش")}</p>
      </div>
      <span className="widgetNum rounded-circle position-absolute fn12 text-white text-center">
        {num}
      </span>
    </div>
  );
};

export { AllWidgets };
